import React, {Component} from 'react';
import {Modal, message} from 'antd';
import {Redirect} from 'react-router';
import aes from '../../../api/aes/public';
import './cashier.less';

class Cashier extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: {}, // 订单详情
      payInfo: [], // 支付信息
      index: 0, // 支付模式 0 返佣账户 1 充值账户 2 在线支付
      payMode: ['返佣账户', '充值账户', '在线支付'], // 支付方式列表

      ModalText: '确认支付当前订单？', // 支付弹窗信息
      visible: false, // 控制支付弹窗的显示隐藏
      confirmLoading: false, // 确定按钮的loading
      redirect: false, // 控制重定向

      sourceCMS: '', // 来源标识
      onlinePayInfo: { // 在线支付信息
        available_balance: '',
        account_no: '',
        account_type: '3'
      }
    };
  }

  async componentWillMount() {
    if (window.common.loginOut(this)) {
      const detail = this.props.location.state.info;

      const sourceCMS = window.localStorage.getItem('sourceCMS') || '';

      await this.setState({
        detail,
        sourceCMS,
        payMode: sourceCMS === '1' ? ['在线支付'] : ['返佣账户', '充值账户', '在线支付'], // 来源标识为1时，只显示在线支付 否则显示所有支付方式
      });

      // 根据支付方式获取相应的支付信息
      this.getPayInfo();
    } else {
      message.error('登录信息失效，请重新登录');
    }
  }

  // 改变付款方式
  changeWay = (index) => {
    this.setState({index});
  }

  // 获取支付信息
  getPayInfo() {
    const {sourceCMS} = this.state;

    // 如果只显示在线支付，不需要获取账户信息
    if (sourceCMS === '1') {
      this.setState({payInfo: [this.state.onlinePayInfo]});
      return;
    }

    const params = {
      login_name: JSON.parse(window.localStorage.getItem('headParams')).login_name
    };
    window.api('Info.getaccountlist', params).then(res => {
      res.account.forEach(item => {
        item.available_balance = (Number(item.available_balance)).toFixed(2);
      });
      // 添加在线支付选项
      const payInfoWithOnline = [...res.account, this.state.onlinePayInfo];
      this.setState({payInfo: payInfoWithOnline});
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }

  // 打开支付窗口
  changeModal = (value) => {
    this.setState({visible: value});
  }

  // 确认支付
  handleOk = () => {
    this.setState({ModalText: '正在支付，请稍候', confirmLoading: true});

    const {
      detail,
      index,
      payInfo,
      sourceCMS
    } = this.state;

    // 判断是否为在线支付
    const isOnlinePay = sourceCMS === '1' || index === 2;

    // 如果是在线支付且金额为0，则阻止支付
    if (isOnlinePay && detail.real_amt === 0) {
      message.error('支付金额需大于0，请切换支付方式！');
      this.setState({visible: false, confirmLoading: false, ModalText: '确认支付当前订单？'});
      return;
    }

    if (isOnlinePay) {
      // 在线支付逻辑
      this.handleOnlinePay(detail);
    } else {
      // 内部账户支付逻辑
      this.handleInnerPay(detail, index, payInfo);
    }
  }

  getUrl = () => {
    let url = ''; // 服务市场地址

    if (window.location.hostname === 'localhost') {
      url = 'https://preeps.51ebill.com'; // 测试
    } else if (window.location.hostname === 'psa-eps.liantuobank.com') {
      url = 'https://preeps.51ebill.com'; // 测试
    } else if (window.location.hostname === 'int-eps.liantuobank.com') {
      url = 'https://inteps.liantuofu.com'; // 灰度
    } else if (window.location.hostname === 'eps.liantuobank.com') {
      url = 'https://neweps.liantuofu.com'; // 生产
    }
    return url;
  }

  // 在线支付处理
  handleOnlinePay = (detail) => {
    const params = {
      order_no: detail.order_no, // 订单号
      pay_mode: '3', // 在线支付模式
      total_amt: detail.real_amt, // 支付金额
      sourceEps: '1', // 是否是eps
      logininfo: {
        PKEY: window.localStorage.getItem('PKEY'),
        fullName: window.localStorage.getItem('fullName'),
        headParams: JSON.parse(window.localStorage.getItem('headParams')),
        identity: window.localStorage.getItem('identity'),
        level: window.localStorage.getItem('level'),
        sourceCMS: window.localStorage.getItem('sourceCMS'),
        lableType: window.localStorage.getItem('lableType'),
      },
    };
    const key = aes.Encrypt(JSON.stringify(params));
    window.location.replace(`${this.getUrl()}/products/checkStand?key=${key}`);
  }

  // 内部账户支付处理
  handleInnerPay = (detail, index, payInfo) => {
    const params = {
      order_no: detail.order_no,
      pay_mode: `${index}`, // 暂时写死 `${index}`
      pay_account_no: payInfo[index].account_no,
      account_balance: payInfo[index].available_balance
    };

    window.api('trade.innerpay', params).then(() => {
      message.success('支付成功');
      this.setState({visible: false, confirmLoading: false, ModalText: '确认支付当前订单？'});
      this.props.history.push('/successfulPayment', {order_no: params.order_no});
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      this.setState({visible: false, confirmLoading: false, ModalText: '确认支付当前订单？'});
      message.error(error.service_error_message);
    });
  }

  // 渲染支付方式列表
  renderPayMethods = () => {
    const {payMode, payInfo, index, detail, sourceCMS} = this.state;

    if (sourceCMS === '1') {
      // 只显示在线支付
      const isDisabled = detail.real_amt === 0; //是否禁用
      return (
        <li
          onClick={isDisabled ? null : this.changeWay.bind(this, 0)}
          key={0}
          className={isDisabled ? 'disabled' : ''}
        >
          <div>
            <span className={index === 0 ? 'isChecked' : 'notChecked'} />
            <p className="name">{payMode[0]}</p>
          </div>
          <p className={index === 0 ? null : 'notChecked'}>支付<span className="price">{detail.real_amt.toFixed(2)}</span>元</p>
        </li>
      );
    }

    // 显示所有支付方式
    return payMode.map((mode, idx) => {

      // idx 0返佣账户  1充值账户  2在线支付
      // payInfo中account_type  1是返佣账户，2是充值账户
      const item = payInfo[idx] || {};
      const accountType = item && item.account_type;
      let accountName = '';
      if (accountType === '1') {
        accountName = '返佣账户';
      } else if (accountType === '2') {
        accountName = '充值账户';
      } else if (accountType === '3') {
        accountName = '在线支付';
      }

      const isOnlinePay = idx === 2; //在线支付
      const isDisabled = isOnlinePay && detail.real_amt === 0; //是否禁用

      return (
        <li
          onClick={isDisabled ? null : this.changeWay.bind(this, idx)}
          key={idx}
          className={isDisabled ? 'disabled' : ''}
        >
          <div>
            <span className={index === idx ? 'isChecked' : 'notChecked'} />
            <p className="name">{accountName}</p>
          </div>
          <p className="remainder">
            {isOnlinePay ? '' : `账户余额: ￥${item.available_balance || '0.00'}`}
          </p>
          <p className={index === idx ? null : 'notChecked'}>支付<span className="price">{detail.real_amt.toFixed(2)}</span>元</p>
        </li>
      );
    });
  }

  render() {
    const {
      visible, confirmLoading, ModalText, detail, redirect
    } = this.state;

    if (redirect) return (<Redirect to="/login" />);

    return (
      <div id="cashier">
        <div>
          <Modal
            visible={visible}
            onOk={this.handleOk}
            confirmLoading={confirmLoading}
            onCancel={this.changeModal.bind(this, false)}
          >
            <p>{ModalText}</p>
          </Modal>
        </div>
        <section className="pay">
          <div>订单提交成功，请尽快付款！订单号：{detail.order_no}</div>
          <div className="money">应付金额<p>{detail.real_amt.toFixed(2)}</p>元</div>
        </section>
        <section className="info">
          {detail.address && <p>收货地址：{detail.address}</p>}
          <p>{detail.type === '1' ? '商品名称' : '套餐名称'}：{detail.goods_name}</p>
        </section>
        <section className="way">
          <div className="title">选择支付方式</div>
          <div className="content">
            <ul>
              {this.renderPayMethods()}
            </ul>
          </div>
        </section>
        <section className="button">
          <button onClick={this.changeModal.bind(this, true)}>立即支付</button>
        </section>
      </div>
    );
  }
}

export default Cashier;



// WEBPACK FOOTER //
// ./src/containers/frontEnd/cashier/cashier.jsx